const statusManipulation = {
  title1: 'Equipo inactivo',
  title2: 'Equipo en mantenimiento',
  title3: 'Equipo apto para uso',
  title4: 'Equipo no apto para uso',
  title5: 'El estado se está consolidando. Recargar la pagina en instantes',
  title6: 'Equipo apto en adecuación',
  title7: 'Equipo sin servicios'
};

export default statusManipulation;
